<!--  -->
<template>
  <div class="">
    <div class="secdbanner"></div>
    <div class="section">
      <div class="crumbsModel">
        您现在的位置： <a href="https://www.nstl.gov.cn">首页</a>
        <a class="no-cache" href="https://cart.nstl.gov.cn">申请单</a>
      </div>
      <div class="section clearfix">
        <div class="techprocess">
          <ul class="clearfix">
            <li class="width400 active">
              <span @click="gocart()"><b>1</b>选择文献</span> <u></u>
            </li>
            <li class="width400 active">
              <span><b>2</b>确认支付</span> <u></u>
            </li>
            <li class="width400 active">
              <span><b>3</b>支付成功</span> <u></u>
            </li>
          </ul>
        </div>
        <div class="bordershadow">
          <div class="subscribebox">
            <div class="subscrirow">
              <div class="searchfuntion">
                <div class="confirmpayment">
                  <div class="echargeHints">
                    <h3 class="fail">
                      <i class="iconfont icon-shibai"></i><b>很遗憾支付失败</b>
                    </h3>
                    <div class="hintstips">
                      <p id="showOderId">
                        申请号：<span id="paySuccess_orderId">{{orderId}}</span>
                      </p>
                      <p id="condition" style="dispaly: none">支付的情况：</p>
                      <div
                        class="table"
                        id="condition-table"
                        style="dispaly: none"
                      >
                        <table class="tables">
                          <thead>
                            <tr>
                              <th>订单号</th>
                              <th width="300px">支付结果</th>
                            </tr>
                          </thead>
                          <tbody id="balance_condition">
                            <tr v-for="(value,key) in data.data" :key="key">
                              <td>
                                {{key}}
                              </td>
                              <td>
                                {{value==1?'支付成功':'支付失败'}}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <p>可能的原因：</p>
                      <p id="detailMessage" style="dispaly: none"></p>
                      <p>1、用户余额不足</p>
                      <p id="message1">2、未完成 支付过程，直接关闭页面。</p>
                      <p id="message2">
                        3、网络原因导致支付过程延迟，请稍后查询个人中心——<a
                          class="no-cache"
                          :href="$store.state.selfservice+'/selfservice/chargecard'"
                          >账务管理</a
                        >
                      </p>
                      <p id="message3">4、如有疑问请联系注册站点客服。</p>

                      <p>
                        前往个人中心——<a
                          class="no-cache"
                          :href="$store.state.selfservice+'/selfservice/docorder'"
                          >申请查询</a
                        >查看
                      </p>
                    </div>
                    <p class="hintstips">
                      <a :href="$store.state.home">返回首页</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
        //支付结果
        orderId:'',
        data:{}
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    gocart(){
        this.$router.push("/cart/select")
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    if (!this.$store.state.isLogin) {
      this.$router.replace("/cart/select")
    }else{
      this.data=JSON.parse(this.$route.params.payResponse)
     this.orderId = this.$route.params.orderId
    }
    
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/cart/Fail.vue